import React, { Component } from "react";
import { connect } from "react-redux";

class Mobile extends Component {
  render() {
    return (
      <div
        style={{
          backgroundColor: "#66C2E2",
          marginTop: "50px"
        }}
      >
        <div style={{ display: "inline-block" }}>
          <div
            style={{
              width: "30%",
              display: "inline-block",
              marginLeft: "30px",
              marginRight: "30px"
            }}
          >
            <img src={require("../assets/accuracy.png")} alt="mobile" />
          </div>
        </div>
        <div
          align="right"
          style={{ width: "70%", display: "inline-block", margin: "20px" }}
        >
          <h5>
            <p>
              <font color="white">
                Get your doppelganger faster with the app
              </font>
            </p>
          </h5>
          <h6>
            <p>
              Upload your photo and you could see who is your doppelgangger.
            </p>
          </h6>
          <h6>
            <p>You could know how you look alike. Try it now!</p>
          </h6>
          <br />
          <center>
            <p>
              <a href="https://play.google.com/store/apps/details?id=com.lookaliker.app">
                <img
                  src={require("../assets/playstore.png")}
                  width="200px"
                  alt="Play Store"
                />
              </a>
            </p>
          </center>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Mobile);



// WEBPACK FOOTER //
// ./src/components/Mobile.js